import * as yup from "yup";

export const overrideSchema = yup
  .object()
  .shape({
    profile: yup
      .object()
      .shape({
        profile_image_url: yup.string().url(),
        name: yup.string(),
        slug: yup.string(),
        title: yup.string(),
        company_name: yup.string(),
        company_slug: yup.string(),
      })
      .noUnknown(),
    pitch_speed_points_score: yup.number(),
    direct_media_reply_points_score: yup.number(),
    conversation_outcome_points_score: yup.number(),
  })
  .noUnknown();

const topPrSchema = yup
  .object()
  .shape({
    bad_behavior_points: yup.number().required(),
    conversation_outcome_points: yup.number().required(),
    direct_media_reply_points: yup.number().required(),
    disabled_interactions_bad_behavior_points: yup.number().required(),
    hidden: yup.boolean().required(),
    ineligible: yup.boolean().required(),
    num_conversations: yup.number().integer().required(),
    num_direct_media_replies: yup.mixed().nullable(),
    num_pitches: yup.number().integer().required(),
    num_represented: yup.number().integer().required(),
    pitch_speed_points: yup.number().required(),
    profile_id: yup.number().integer().required(),
    profile_slug: yup.string().required(),
    spam_flagged_count_bad_behavior_points: yup.number().required(),
    suspected_leaker_dialog_enabled_count_bad_behavior_points: yup.number().required(),
    total_points: yup.number().required(),
    v1_profile_id: yup.string().required(),
    v1_user_id: yup.number().integer().nullable(),
    override: overrideSchema.optional(),
  })
  .noUnknown();

export const topPrsSchema = yup.array().of(topPrSchema);
